// extracted by mini-css-extract-plugin
export var dataCell = "_r2-2";
export var dataRow = "_r2-0";
export var headerRow = "_r2-1";